// extracted by mini-css-extract-plugin
module.exports = {"mobileInvestigationDetails":"styles_mobileInvestigationDetails__1S3f2","accordionItem":"styles_accordionItem__133hm","open":"styles_open__GtP6H"};